export const CertificateContractAddress =
  "0xFdf78500Cf30e6C433d4EE48065AB261b76fE063";
